<template>
  <Fragment>
    <div class="row">
      <div class="col-6">
        <h5>{{ steps.fleetDetails.displayName }}</h5>

        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Tractor</th>
              <th scope="col">Trailer</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Total Units</th>
              <td>{{ values.fleetDetails.tractor.total }}</td>
              <td>{{ values.fleetDetails.trailer.total }}</td>
            </tr>
            <tr>
              <th scope="row">Annual Distance (<small>miles</small>)</th>
              <td>
                {{ integer(values.fleetDetails.tractor.annualDistance) }}
              </td>
              <td>
                {{ integer(values.fleetDetails.trailer.annualDistance) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-6">
        <h5>{{ steps.maintenance.displayName }}</h5>

        <table class="table table-sm">
          <tbody>
            <tr>
              <th scope="row">Tire Checks (<small>per month</small>)</th>
              <td>{{ values.maintenance.numberOfChecks }}</td>
            </tr>
            <tr>
              <th scope="row">Time per Check (<small>minutes</small>)</th>
              <td>
                {{ integer(values.maintenance.laborTime) }}
              </td>
            </tr>
            <tr>
              <th scope="row">Avg. Hourly Labor Rate (<small>USD</small>)</th>
              <td>${{ number(values.maintenance.laborRate) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-6">
        <h5>{{ steps.tires.displayName }}</h5>

        <table class="table table-sm">
          <tbody>
            <tr>
              <th scope="row">Tire Style</th>
              <td>{{ values.tires.tireStyle }}</td>
            </tr>
            <tr>
              <th scope="row">Cost of Tire (<small>USD</small>)</th>
              <td>${{ number(values.tires.costOfTire) }}</td>
            </tr>
            <tr>
              <th scope="row">Tire Life (<small>miles</small>)</th>
              <td>{{ integer(values.tires.tireLife) }}</td>
            </tr>
          </tbody>
        </table>

        <h5>{{ steps.fuel.displayName }}</h5>

        <table class="table table-sm">
          <tbody>
            <tr>
              <th scope="row">Cost of Fuel (<small>USD/gallon</small>)</th>
              <td>${{ number(values.fuel.costOfFuel) }}</td>
            </tr>
            <tr>
              <th scope="row">Avg. Fuel Mileage (<small>MPG</small>)</th>
              <td>{{ number(values.fuel.tractorMPG) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-6">
        <h5>{{ steps.roadCalls.displayName }}</h5>

        <table class="table table-sm">
          <tbody>
            <tr>
              <th scope="row">
                Trailer Tire-Related Road Calls (<small>per year</small>)
              </th>
              <td>
                {{ number(values.roadCalls.tireRelatedBreakdownsPerYear) }}
              </td>
            </tr>
            <tr>
              <th scope="row">Tire Replacement Cost (<small>USD</small>)</th>
              <td>${{ number(values.roadCalls.tireReplacementCost) }}</td>
            </tr>
            <tr>
              <th scope="row">Road Call Downtime (<small>hours</small>)</th>
              <td>{{ number(values.roadCalls.downtimeRoadCallsHours) }}</td>
            </tr>
            <tr>
              <th scope="row">Downtime Cost per Hour (<small>USD</small>)</th>
              <td>${{ number(values.roadCalls.downtimePerHourCost) }}</td>
            </tr>
            <tr>
              <th scope="row">Cost of Service Call (<small>USD</small>)</th>
              <td>${{ number(values.roadCalls.costOfRoadCalls) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

import { mapState } from '@/src/roi-calculator/store';
import {
  formatNumber,
  formatNumberAsInteger,
} from '@/src/utilities/formatters';
export default {
  name: 'SummaryTotals',

  components: { Fragment },

  computed: {
    ...mapState(['stepsSet', 'formValues']),

    /** @returns {StepsSet} */
    steps() {
      formatNumberAsInteger;
      return this.stepsSet;
    },

    /** @returns {FormData} */
    values() {
      return this.formValues;
    },
  },

  methods: {
    integer: formatNumberAsInteger,
    number: formatNumber,
  },
};

/**
 * @typedef {import('../../store/state').StepsSet} StepsSet
 * @typedef {import('../../store/state').FormData} FormData
 */
</script>
